import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      height: '40em',
      width: '80em',
    },
  }),
  async mounted() {
    this.renderChart(this.chartdata, this.options)
  },
}
